export default __webpack_public_path__ + "static/media/994.bbe58a3e.gif";